import 'intl';

import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/nl';

import en from 'react-intl/locale-data/en';
import nl from 'react-intl/locale-data/nl';

export default { en, nl };
